import * as loginModal from './ost.modal-dialog'

export class LoginModalDialog extends loginModal.ModalDialog {
    constructor(selector) {
        super(selector);
    }

    init() {
        $(document).on('click', '.js-login-button', (e) => this.loginFormSubmit(e));
        super.init();
    }

    loginFormSubmit(e) {
        e.preventDefault();
        let $button = $(e.currentTarget);
        let $form = $button.closest("form");

        const modalBody = $('#js-login-modal-body');
        const loader = $('.loader');
 
        $('#login-form-errors').hide();

        if (!$form.valid())
            return;

        $button.addClass("disabled").button("loading");

        modalBody.css('visibility', 'hidden');
        loader.removeClass('hide');

        var updateUrl = $form.attr("action");
        var data = $form.serialize();

        $.ajax({
            url: updateUrl,
            type: "POST",
            data: data,
            success: (data, textStatus, jqXHR) => {
                if (data.success === true) {
                    if (data.redirectUrl) {
                        this.$currentModal.one('hidden.bs.modal',
                            (e2) => {
                                super.getAndLoadDiv(data.redirectUrl, ".modal");
                            });
                        this.$currentModal.modal("hide");
                    } else
                        window.location.reload(true);
                }
                else if (data.errors) {
                    modalBody.css('visibility', 'visible');
                    loader.addClass('hide');

                    this.setLoginErrorMessage("", true);
                    $('#login-form-errors').show();
                    for (var error in data.errors) {
                        this.setLoginErrorMessage(data.errors[error] + '<br />');
                    }
                }
            },
            error: (resp) => {
                this.setLoginErrorMessage("Ett fel inträffade", true);
            }
        });

        return false;
    }
    
    setLoginErrorMessage(msg, clearFirst) {
        if (clearFirst)
            $('#login-form-errors').html("");

        if(msg)
            $('#login-form-errors').append(msg);
    }
}


// WEBPACK FOOTER //
// ./frontend/js/components/ost.login-modal-dialog.js